import { useTranslation } from 'react-i18next';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import FormTextInput from 'components/FormTextInput/TypedFormTextInput';

export type GoogleConfig = {
  enabled: boolean;
  id: string | null;
  secret: string | null;
  isGoogleOneTapEnabled: boolean;
};

type GoogleConfigCardProps = {
  config: GoogleConfig;
  classes: { [key: string]: string };
  onChange: (config: GoogleConfig) => void;
};

const GoogleConfigCard = ({
  config,
  classes,
  onChange,
}: GoogleConfigCardProps) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardBody>
        <LabeledCheckbox
          checked={config.enabled}
          onChange={() => onChange({ ...config, enabled: !config.enabled })}
          label={t('brands.newBrandForm.viaGoogle')}
        />

        <FormTextInput
          label="Google CLIENT ID"
          classes={classes}
          name="googleClientId"
          value={config.id}
          maxLength={128}
          handleChange={e => onChange({ ...config, id: e.target.value })}
          inputSize={6}
        />
        <FormTextInput
          label="Google SECRET KEY"
          classes={classes}
          name="googleClientSecret"
          value={config.secret}
          maxLength={64}
          handleChange={e => onChange({ ...config, secret: e.target.value })}
          inputSize={6}
        />
        <LabeledCheckbox
          checked={config.isGoogleOneTapEnabled}
          onChange={() =>
            onChange({
              ...config,
              isGoogleOneTapEnabled: !config.isGoogleOneTapEnabled,
            })
          }
          label={t('brands.newBrandForm.useGoogleOneTap')}
        />
      </CardBody>
    </Card>
  );
};

export default GoogleConfigCard;
